// データタブのパネル（非空間 CSV の取込と一覧）。
//
// 役割: 位置情報を持たない CSV をアップロードし、取り込んだデータテーブルを一覧する。
//       各行の詳細ボタンでプレビューモーダル（DataTableModal）を開き、削除もできる。
//       地図には載せず、エージェントが SQL JOIN する材料として扱う（LayerPanel の非空間版）。
// 関係: dataTables は data-store の配列。取込/削除は App 経由で useDataActions に伝わる。
import { useState } from 'react'

import FileUpload from './FileUpload'
import DataTableModal from './DataTableModal'

function DataTableRow({ table, onRemove, onShowDetail, onMention }) {
  return (
    <li className="layer-row">
      <div className="layer-row-main">
        <span className="layer-name">
          <code>{table.displayName ?? table.tableId}</code>{' '}
          <small>
            ({table.columns.length} 列・{table.rowCount} 行)
          </small>
        </span>
        <button
          className="icon-btn"
          onClick={() => onMention(table.tableId)}
          title="プロンプトにデータIDを送る"
        >
          @
        </button>
        <button className="icon-btn" onClick={() => onShowDetail(table)} title="データ詳細">
          ⓘ
        </button>
        <button
          className="icon-btn danger"
          onClick={() => onRemove(table.tableId)}
          title="削除"
        >
          ×
        </button>
      </div>
    </li>
  )
}

function DataPanel({ dataTables, busy, onDataFiles, onRemove, onMention }) {
  const [detailTable, setDetailTable] = useState(null)

  return (
    <div className="layers-tab">
      <FileUpload
        onFiles={onDataFiles}
        busy={busy}
        accept=".csv"
        hint="位置情報なしの CSV（属性テーブル）"
      />

      <div className="layer-panel">
        <div className="layer-panel-header">
          <h3>データテーブル（{dataTables.length}）</h3>
        </div>

        {dataTables.length === 0 ? (
          <p className="empty-state">
            位置情報を持たない CSV を取り込むと、プロンプトでレイヤーと結合できます。
          </p>
        ) : (
          <ul className="layer-list">
            {dataTables.map((t) => (
              <DataTableRow
                key={t.tableId}
                table={t}
                onRemove={onRemove}
                onShowDetail={setDetailTable}
                onMention={onMention}
              />
            ))}
          </ul>
        )}
      </div>

      {detailTable && (
        <DataTableModal
          key={detailTable.tableId}
          table={detailTable}
          onClose={() => setDetailTable(null)}
        />
      )}
    </div>
  )
}

export default DataPanel
